var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "stores" } }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-12" },
          [
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c(
              "router-link",
              { staticClass: "all", attrs: { to: "/descontosdobem" } },
              [_vm._v("veja mais")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-12" }, [
          _vm.featuredStores
            ? _c(
                "div",
                { staticClass: "stores row" },
                _vm._l(_vm.featuredStores, function(c) {
                  return _c(
                    "div",
                    { key: c.StoreId, staticClass: "col-md-2" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "item",
                          on: {
                            click: function($event) {
                              return _vm.openStore(c.slug)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "image" }, [
                            _c("img", { attrs: { src: c.logo } })
                          ])
                        ]
                      )
                    ]
                  )
                }),
                0
              )
            : _c("div", { staticClass: "waiting row" }, [
                _c("h4", [_vm._v("Aguarde, carregando...")])
              ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title d-none d-sm-block" }, [
      _vm._v("\n              Aproveite cupons de descontos em nossas "),
      _c("span", [_vm._v("lojas afiliadas")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title d-block d-sm-none" }, [
      _vm._v("\n              Lojas "),
      _c("span", [_vm._v("afiliadas")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0efb5a13", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0efb5a13","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/StoresSection.vue
// module id = null
// module chunks = 